import { setPropertySchema } from '../utils/helpers';
import { Buttons } from './elements/buttons';
import { Dropdowns } from './elements/dropdowns';
import { Input } from './elements/inputs';
import { Textarea } from './elements/textarea';

export class Form {
  Input = {};
  Dropdowns = {};
  Buttons = {};
  Textarea = {};
  blocklist;

  constructor(form, name) {
    this.dressFormElement(form, name);
  }

  static async create(form, name) {
    const instance = new Form(form, name);
    const res = await instance.getAttributeBlockList();
    if (!res) throw new Error('Failed to get privacy rules');

    const blockList = await instance.makeBlockedList(res);
    instance.blocklist = blockList;

    instance.Input = new Input(form, name, blockList);
    instance.Dropdowns = new Dropdowns(form, name, blockList);
    instance.Buttons = new Buttons(form, name, blockList);
    instance.Textarea = new Textarea(form, name, blockList);

    return instance;
  }

  dressForm() {
    this.Input.dressInputs();
    this.Dropdowns.dressDropdowns();
    this.Buttons.dressButtons();
    this.Textarea.dressTextAreas();
  }

  dressFormElement = (form, name) => {
    form.setAttribute('data-fs-element', 'form');
    form.setAttribute('data-fs-form-name', name);
    setPropertySchema(form);
  };

  async getScriptJSONContent(src) {
    const res = await fetch(src);
    if (!res.ok) {
      throw new Error(`Request failed with status ${res.status}`);
    }
    return res;
  }

  async getAttributeBlockList() {
    if (this.hasFs()) {
      const host = window._fs_host;
      const settings = window._fs_rec_settings_host;
      const org_id = window._fs_org;
      const settingsHost = settings ?? 'edge.' + host;
      const settingsURL = `https://${settingsHost}/s/settings/${org_id}/v1/web`;
      const res = await this.getScriptJSONContent(settingsURL);
      return await res.json();
    }
  }

  async makeBlockedList(json) {
    const blockList = [];

    json.ElementBlocks.forEach((x) => {
      if (!x.Consent) {
        blockList.push(x.Selector);
      }
    });

    json.NamedElementBlocks.forEach((x) => {
      if (!x.Consent) {
        const selector = x.TargetedSelectorsForCapture[0].Selector;
        blockList.push(selector);
      }
    });

    return blockList;
  }

  hasFs() {
    if (typeof window._fs_namespace === 'string') {
      const fsNamespace = window._fs_namespace;
      return typeof window[fsNamespace]?.getCurrentSessionURL === 'function';
    }
    return false;
  }
}
